// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JMY37","footer":"styles_footer__qx8Th","passCodeTooltip":"styles_passCodeTooltip__3LoxF"};